<script setup>
  import { onMounted, ref } from 'vue';
  const activeTab = ref('tab1')
  const onTabChange = (tab) => {
    activeTab.value = tab
  }
  const fundTab = ref(0)
  const onFundTabChange = (tab) => {
    fundTab.value = tab
  }
  const scrollFun = (e) => {
    var t = e.target
      , a = t.getBoundingClientRect().left
      , n = Array.from(t.children).find((function (e) {
        return e.getBoundingClientRect().left >= a - 100
      }
      ));
    n && Number(null === n || void 0 === n ? void 0 : n.dataset.slideNumber)
  }
  const fundCategories = {
    "key": "discover_skeleton_v1_categories",
    "data": [
      {
        "title": "Equity",
        "sections": [
          {
            "title": "By market capitalisation",
            "categories": [
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Large-Cap"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Large-Cap",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Large-Cap"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/L.png",
                "description": "Invests at least 80% in India's top 100 companies",
                "shortDescription": "Invests at least 80% in India's top 100 companies",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Mid-Cap"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Mid-Cap",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Mid-Cap"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/M.png",
                "description": "Invests at least 65% in companies ranking between 101-250 in terms of market cap",
                "shortDescription": "Invests at least 65% in companies ranking between 101-250 in terms of market cap",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Small-Cap"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Small-Cap",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Small-Cap"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invests at least 65% in companies ranking beyond 250 in terms of market cap",
                "shortDescription": "Invests at least 65% in companies ranking beyond 250 in terms of market cap",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Large \u0026 Mid- Cap"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Large \u0026 Mid-Cap",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Large \u0026 Mid-Cap"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/L.png",
                "description": "Invests in India's top 250 companies",
                "shortDescription": "Invests in India's top 250 companies",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "By diversification",
            "categories": [
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Flexi Cap"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Flexi Cap",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Flexi Cap"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/F.png",
                "description": "Invests in companies across all market cap",
                "shortDescription": "Invests in companies across all market cap",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Multi-Cap"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Multi-Cap",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Multi-Cap"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/M.png",
                "description": "Invests at least 65% in companies of all sizes ",
                "shortDescription": "Invests at least 65% in companies of all sizes ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Focused Fund"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Focused Funds",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Focused Fund"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/F.png",
                "description": "Invests using concentrated portfolio strategy by investing in maximum 30 companies",
                "shortDescription": "Invests using concentrated portfolio strategy by investing in maximum 30 companies",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Value"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Value",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Value"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/V.png",
                "description": "Value oriented funds that largely follow a value investment strategy with at least 65% in stocks",
                "shortDescription": "Value oriented funds that largely follow a value investment strategy with at least 65% in stocks",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Global - Other"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Global",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Global - Other"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/G.png",
                "description": "Invests in markets outside India",
                "shortDescription": "Invests in markets outside India",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Index Funds"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Tracking Error",
                    "value": "trackErrVsCategory",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 4,
                    "title": "Fund Size",
                    "value": "AUMVsCategory",
                    "sortOrder": "desc"
                  }
                ],
                "title": "Index Funds",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Index Funds"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/I.png",
                "description": "Index Funds are a low cost way to track market indices like the NIFTY and Sensex.",
                "shortDescription": "Index Funds are a low cost way to track market indices like the NIFTY and Sensex.",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "By solution",
            "categories": [
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "ELSS (Tax Savings)"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "ELSS (Tax Savings)",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "ELSS (Tax Savings)"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/E.png",
                "description": "Invest in top ELSS funds to invest in equity and also save up to ₹46,800 in taxes!",
                "shortDescription": "Invest in top ELSS funds to invest in equity and also save up to ₹46,800 in taxes!",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "By sectors \u0026 themes",
            "categories": [
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Dividend yield"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Dividend Yield",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Dividend Yield"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/T.png",
                "description": "Invests at least 65% in dividend yielding stocks",
                "shortDescription": "Invests at least 65% in dividend yielding stocks",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Sector - Financial Services"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Sector - Financial Services",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Sector - Financial Services"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invests at least 80% in companies from the Financial Services sector",
                "shortDescription": "Invests at least 80% in companies from the Financial Services sector",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Sector - Technology"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Sector - Technology",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Sector - Technology"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invests at least 80% in companies from the Technology/IT sector",
                "shortDescription": "Invests at least 80% in companies from the Technology/IT sector",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Infrastructure"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Equity - Infrastructure",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Infrastructure"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invests in companies tied to the Infrastructure theme",
                "shortDescription": "Invests in companies tied to the Infrastructure theme",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Sector - FMCG"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Sector - FMCG",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Sector - FMCG"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invests at least 80% in companies from the FMCG sector",
                "shortDescription": "Invests at least 80% in companies from the FMCG sector",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Consumption"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Equity - Consumption",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Consumption"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/T.png",
                "description": "Invests in companies tied to the consumption theme",
                "shortDescription": "Invests in companies tied to the consumption theme",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Sector - Healthcare"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Sector - Healthcare",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Sector - Healthcare"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invests at least 80% in companies from the Healthcare sector",
                "shortDescription": "Invests at least 80% in companies from the Healthcare sector",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "ESG"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Equity - ESG",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "ESG"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/T.png",
                "description": "'ESG (environmental, social, and governance)' funds that invest in stocks tied to the ESG theme.",
                "shortDescription": "'ESG (environmental, social, and governance)' funds that invest in stocks tied to the ESG theme.",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Arbitrage Fund"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Arbitrage Funds",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "E",
                        "name": "Equity",
                        "selected": [
                          "Arbitrage Fund"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/A.png",
                "description": "Invests in Arbitrage Funds to benefit from price differential in the same or related financial instrument markets",
                "shortDescription": "Invests in Arbitrage Funds to benefit from price differential in the same or related financial instrument markets",
                "showSmartFilters": true
              }
            ]
          }
        ]
      },
      {
        "title": "Fixed Income",
        "sections": [
          {
            "title": "Park your savings",
            "categories": [
              {
                "query": {
                  "sortBy": "topFunds",
                  "sortOrder": "desc",
                  "categories": [
                    "Overnight"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Overnight",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Overnight"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/O.png",
                "description": "Invest in top low-risk, overnight, fixed-income funds backed by the GOI. They're better than a savings account! ",
                "shortDescription": "Invest in top low-risk, overnight, fixed-income funds backed by the GOI. They're better than a savings account! ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "topFunds",
                  "sortOrder": "desc",
                  "categories": [
                    "Liquid"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Liquid",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Liquid"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/L.png",
                "description": "Lends to companies for up to 91 days",
                "shortDescription": "Lends to companies for up to 91 days",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Ultra Short Duration"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Ultra Short Duration ",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Ultra Short Duration"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/U.png",
                "description": "Lends to companies for a period of 3 to 6 months.",
                "shortDescription": "Lends to companies for a period of 3 to 6 months.",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Low Duration"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Low Duration",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Low Duration"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/L.png",
                "description": "Lends to companies for 6 to 12 months ",
                "shortDescription": "Lends to companies for 6 to 12 months ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Money Market"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Money Market",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Money Market"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/M.png",
                "description": "Lends to companies for a period of 1 year",
                "shortDescription": "Lends to companies for a period of 1 year",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "Better than FDs",
            "categories": [
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Banking \u0026 PSU"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Banking \u0026 PSU",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Banking \u0026 PSU"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/B.png",
                "description": "Invests minimum 80% in fixed income instruments issued by banks , PSUs etc.",
                "shortDescription": "Invests minimum 80% in fixed income instruments issued by banks , PSUs etc.",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Corporate Bond"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Corporate Bond",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Corporate Bond"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/C.png",
                "description": "Invests minimum 80% in corporate bonds with AA+ and above credit rating",
                "shortDescription": "Invests minimum 80% in corporate bonds with AA+ and above credit rating",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Short Duration"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Short Duration",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Short Duration"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Lends to companies for 1 to 3 years ",
                "shortDescription": "Lends to companies for 1 to 3 years ",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "Fixed Income for long-term",
            "categories": [
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Medium Duration"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Medium Duration",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Medium Duration"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/M.png",
                "description": "Lends to companies for 3 to 4 years ",
                "shortDescription": "Lends to companies for 3 to 4 years ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Medium to Long Duration"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Medium to Long Duration",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Medium to Long Duration"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/M.png",
                "description": "Lends to companies for 4 - 7 years",
                "shortDescription": "Lends to companies for 4 - 7 years",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Long Duration"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Long Duration",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Long Duration"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/L.png",
                "description": "Lends to companies for 7+ years",
                "shortDescription": "Lends to companies for 7+ years",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Dynamic Bond"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Dynamic Bond",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Dynamic Bond"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/D.png",
                "description": "Dynamically lend to companies for the long to short term",
                "shortDescription": "Dynamically lend to companies for the long to short term",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "10 yr Government Bond"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Government Bond",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "10 yr Government Bond"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/G.png",
                "description": "Invest in Government Bonds, a fixed-income security issued by the GOI",
                "shortDescription": "Invest in Government Bonds, a fixed-income security issued by the GOI",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "Others",
            "categories": [
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Credit Risk"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Credit Risk",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Credit Risk"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/C.png",
                "description": "Invests minimum 65% in corporate bonds with AA and below credit rating",
                "shortDescription": "Invests minimum 65% in corporate bonds with AA and below credit rating",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Index Funds - Fixed Income"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "YTM",
                    "value": "ytmVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Maturity Date",
                    "value": "maturityDate",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 5,
                    "title": "Credit rating",
                    "value": "creditRating",
                    "sortOrder": "desc"
                  }
                ],
                "title": "Fixed Income - Index",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Index Funds - Fixed Income"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/I.png",
                "description": "Invest in funds that track a fixed income index ",
                "shortDescription": "Invest in funds that track a fixed income index ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Floating Rate"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Floating Rate",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "D",
                        "name": "Fixed Income",
                        "selected": [
                          "Floating Rate"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/F.png",
                "description": "Funds that focus on investments with floating interest rates",
                "shortDescription": "Funds that focus on investments with floating interest rates",
                "showSmartFilters": true
              }
            ]
          }
        ]
      },
      {
        "title": "Hybrid",
        "sections": [
          {
            "title": "By Equity Fixed Income allocation",
            "categories": [
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Aggressive Allocation"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Aggressive Allocation",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Aggressive Allocation"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/A.png",
                "description": "Invests 65% to 80% in equity and remaining in fixed income instruments ",
                "shortDescription": "Invests 65% to 80% in equity and remaining in fixed income instruments ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Equity Savings"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Equity Savings",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Equity Savings"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/E.png",
                "description": "Invest almost an equal amount in stocks, FD-like instruments and derivatives",
                "shortDescription": "Invest almost an equal amount in stocks, FD-like instruments and derivatives",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Conservative Allocation"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Conservative Allocation",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Conservative Allocation"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/C.png",
                "description": "Invests 75% to 90% in fixed income instruments and remaining in equity",
                "shortDescription": "Invests 75% to 90% in fixed income instruments and remaining in equity",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "By solution",
            "categories": [
              {
                "query": {
                  "sortBy": "priority",
                  "sortOrder": "desc",
                  "categories": [
                    "Dynamic Asset Allocation"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "Top funds",
                    "value": "topFunds"
                  },
                  {
                    "key": 1,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 2,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 3,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 4,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Dynamic Asset Allocation",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Dynamic Asset Allocation"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/D.png",
                "description": "Dynamically invest in equity and fixed income ",
                "shortDescription": "Dynamically invest in equity and fixed income ",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Multi Asset Allocation"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Multi Asset Allocation",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Multi Asset Allocation"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/M.png",
                "description": "Invests in at least 3 asset classes(stocks, bonds, commodities, real estate, etc.) with a minimum allocation of at least 10% in each asset class",
                "shortDescription": "Invests in at least 3 asset classes(stocks, bonds, commodities, real estate, etc.) with a minimum allocation of at least 10% in each asset class",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Retirement"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Retirement",
                "bgColor": "#FD8E6E",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Retirement"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/R.png",
                "description": "Invest in a mix of equities and fixed income securities with a lock-in for at least 5 years or till retirement age whichever is earlier",
                "shortDescription": "Invest in a mix of equities and fixed income securities with a lock-in for at least 5 years or till retirement age whichever is earlier",
                "showSmartFilters": true
              },
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Children"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Children Funds",
                "bgColor": "#FCBC69",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Children"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/C.png",
                "description": "Invest in a mix of equities and fixed income securities with a lock-in for at least 5 years or till the child attains age of majority whichever is earlier",
                "shortDescription": "Invest in a mix of equities and fixed income securities with a lock-in for at least 5 years or till the child attains age of majority whichever is earlier",
                "showSmartFilters": true
              }
            ]
          },
          {
            "title": "Others",
            "categories": [
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Fund of Funds"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Fund of Funds",
                "bgColor": "#7ACECE",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "H",
                        "name": "Hybrid",
                        "selected": [
                          "Fund of Funds"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/F.png",
                "description": "Invests in other mutual funds",
                "shortDescription": "Invests in other mutual funds",
                "showSmartFilters": true
              }
            ]
          }
        ]
      },
      {
        "title": "Commodities",
        "sections": [
          {
            "title": "Metals",
            "categories": [
              {
                "query": {
                  "sortBy": "threeYearReturn",
                  "sortOrder": "desc",
                  "categories": [
                    "Sector - Precious Metals"
                  ],
                  "smartListName": [
                    "topFunds"
                  ]
                },
                "sorts": [
                  {
                    "key": 0,
                    "title": "3Y CAGR",
                    "value": "threeYearReturn",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 1,
                    "title": "Expense ratio",
                    "value": "expRatio",
                    "sortOrder": "asc"
                  },
                  {
                    "key": 2,
                    "title": "Return vs category",
                    "value": "returnVsCategory",
                    "sortOrder": "desc"
                  },
                  {
                    "key": 3,
                    "title": "Risk vs category",
                    "value": "riskVsCategory",
                    "sortOrder": "asc"
                  }
                ],
                "title": "Sector - Precious Metals",
                "bgColor": "#AF93CF",
                "filters": [
                  {
                    "key": "categories",
                    "name": "Category",
                    "show": true,
                    "multi": false,
                    "disabled": true,
                    "categories": [
                      {
                        "key": "G",
                        "name": "Commodities",
                        "selected": [
                          "Sector - Precious Metals"
                        ]
                      }
                    ]
                  },
                  {
                    "key": "schemeClasses",
                    "name": "Fund plan",
                    "show": true,
                    "multi": true,
                    "disabled": false,
                    "selected": [
                      "Growth"
                    ]
                  }
                ],
                "logoUrl": "https://assets.upstox.com/content/dam/aem-content-integration/assets/images/default/S.png",
                "description": "Invest in funds which invest in commodities like Gold and Silver",
                "shortDescription": "Invest in funds which invest in commodities like Gold and Silver",
                "showSmartFilters": true
              }
            ]
          }
        ]
      }
    ]
  }
  
const loadCSS = (path) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = path;
  document.head.appendChild(link);
  return link;
};

  onMounted(() => {
    $('body').removeAttr('class')
    require("@/assets/js/styles.f7304a2557c79197721e.js")
    $(".carousel").carousel('cycle')
  })

</script>
<template>
  <div class="truthsAboutInvesting">
    <div class="foldContainer">
      <div class="headingRow">
        <div>
          <img width="79" height="21" src="@/styles/img/2bb9f5c5a3edf6ee2f05f3c9c1822be3.svg" alt="Uplearn" />
          <h2 class="heading">Truths about investing</h2>
        </div>
        <button aria-label="View more or less" class="viewMore">
          <span class="toggleText">View less</span><span class="iconWrapper"><span class="icon full"><svg
                viewBox="0 0 24 24" role="presentation">
                <path d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" style="fill: currentColor">
                </path>
              </svg></span></span>
        </button>
      </div>
      <div class="truthsCarousel">
        <div class="carouselContainer">
          <div class="carousel" @scroll="scrollFun">
            <div class="carouselSlide slideWidth" data-slide-number="1" style="
                scroll-snap-align: start;
                margin-right: 12px;
                margin-left: 12px;
              ">
              <div class="slide">
                <div class="slideContent">
                  A SIP of ₹5000/month started 25 years ago could've made you a
                  crorepati by now
                </div>
                <span class="slideNumber">1</span><button class="readMore viewMore">Read more</button>
              </div>
            </div>
            <div class="carouselSlide slideWidth" data-slide-number="2" style="
                scroll-snap-align: start;
                margin-right: 12px;
                margin-left: 12px;
              ">
              <div class="slide">
                <div class="slideContent">'Not investing' is risky</div>
                <span class="slideNumber">2</span><button class="readMore viewMore">Read more</button>
              </div>
            </div>
            <div class="carouselSlide slideWidth" data-slide-number="3" style="
                scroll-snap-align: start;
                margin-right: 12px;
                margin-left: 12px;
              ">
              <div class="slide">
                <div class="slideContent">
                  Invest in Index Funds to match NIFTY 50 returns
                  #MustForEveryInvestor
                </div>
                <span class="slideNumber">3</span><button class="readMore viewMore">Read more</button>
              </div>
            </div>
            <div class="carouselSlide slideWidth" data-slide-number="4" style="
                scroll-snap-align: start;
                margin-right: 12px;
                margin-left: 12px;
              ">
              <div class="slide">
                <div class="slideContent">
                  Invest in stocks and save up to ₹46,800 in taxes
                </div>
                <span class="slideNumber">4</span><button class="readMore viewMore">Read more</button>
              </div>
            </div>
            <div class="carouselSlide slideWidth" data-slide-number="5" style="
                scroll-snap-align: start;
                margin-right: 12px;
                margin-left: 12px;
              ">
              <div class="slide">
                <div class="slideContent">
                  Don't put all your eggs in one basket
                </div>
                <span class="slideNumber">5</span><button class="readMore viewMore">Read more</button>
              </div>
            </div>
            <div class="carouselSlide slideWidth" data-slide-number="6" style="
                scroll-snap-align: start;
                margin-right: 12px;
                margin-left: 12px;
              ">
              <div class="slide">
                <div class="slideContent">
                  Mutual Funds on Upstox are Direct Plans &amp; are free of any
                  charges
                </div>
                <span class="slideNumber">6</span><button class="readMore viewMore">Read more</button>
              </div>
            </div>
          </div>
        </div>
        <div class="slideIndicator indicators">
          <div class="activeSlide">1 / 6</div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div class="arrowContainer truthsCarouselArrows">
          <button class="carouselArrow" data-slide="prev">
            <span class="icon medium"><svg viewBox="0 0 24 24" role="presentation">
                <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
                  style="fill: currentColor"></path>
              </svg></span></button><button class="carouselArrow" data-slide="next">
            <span class="icon medium"><svg viewBox="0 0 24 24" role="presentation">
                <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                  style="fill: currentColor"></path>
              </svg></span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="topFundIdeas">
    <div class="topFundIdeasDesktop">
      <div class="largeTabs">
        <div class="tab bottom" :class="{ active: activeTab === 'tab1' }" @click="onTabChange('tab1')">
          <span data-id="Match NIFTY 50 returns">Match NIFTY 50 returns</span>
        </div>
        <div class="tab bottom" :class="{ active: activeTab === 'tab2' }" @click="onTabChange('tab2')">
          <span data-id="Alternative to savings account">Alternative to savings account</span>
        </div>
        <div class="tab bottom" :class="{ active: activeTab === 'tab3' }" @click="onTabChange('tab3')">
          <span data-id="Save taxes">Save taxes</span>
        </div>
      </div>
      <p class="listDescription">
        <template v-if="activeTab==='tab1'">Index Funds are a low cost way to track NIFTY 50 returns and invest in
          India’s growth</template>
        <template v-if="activeTab==='tab2'">Invest in top low-risk, overnight, fixed-income funds backed by the GOI.
          They're better than a savings account! </template>
        <template v-if="activeTab==='tab3'">Invest in top ELSS funds to invest in equity and also save up to ₹46,800 in
          taxes! </template>
      </p>
      <template v-if="activeTab==='tab1'">
        <div class="content">
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245)">
            <img src="@/styles/img/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated" />
            <div class="topRatedFundsData">
              <img src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000AJYO.png" class="logo"
                alt="UTI Nifty 50 Index Fund" width="32" height="32" loading="lazy" />
              <div>
                <h3>UTI Nifty 50 Index Fund</h3>
                <span class="subText">Equity • Index • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">10.96%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.17%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Tracking error</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">Low</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Fund size</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">High</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245)">
            <img src="@/styles/img/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated" />
            <div class="topRatedFundsData">
              <img src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000953D.png" class="logo"
                alt="ICICI Prudential Nifty 50 Index Fund" width="32" height="32" loading="lazy" />
              <div>
                <h3>ICICI Prudential Nifty 50 Index Fund</h3>
                <span class="subText">Equity • Index • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">10.91%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.18%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Tracking error</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">Low</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Fund size</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">High</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245)">
            <img src="@/styles/img/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated" />
            <div class="topRatedFundsData">
              <img src="https://assets.upstox.com/content/assets/images/fundhouse/0C00009534.png" class="logo"
                alt="HDFC Nifty 50 Index Fund" width="32" height="32" loading="lazy" />
              <div>
                <h3>HDFC Nifty 50 Index Fund</h3>
                <span class="subText">Equity • Index • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">10.92%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.2%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Tracking error</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">Low</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Fund size</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">High</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245)">
            <img src="@/styles/img/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated" />
            <div class="topRatedFundsData">
              <img src="https://assets.upstox.com/content/assets/images/fundhouse/0C00003HJY.png" class="logo"
                alt="SBI Nifty Index Fund" width="32" height="32" loading="lazy" />
              <div>
                <h3>SBI Nifty Index Fund</h3>
                <span class="subText">Equity • Index • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">10.96%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.23%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Tracking error</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">Low</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Fund size</div>
                <div class="infoValue">
                  <div class="ratingIndicator">
                    <span style="color: rgb(20, 133, 100)">High</span>
                    <div class="iconContainer smallIcon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16"
                        fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="activeTab==='tab2'">
        <div class="content">
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C00003HJY.png" class="logo"
                alt="SBI Overnight Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>SBI Overnight Fund</h3><span class="subText">Fixed Income • Overnight • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">6.15%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.07%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns on Maturity</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(219, 84, 42);">Below Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#DB542A" opacity="0.3"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#DB542A" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#DB542A" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Credit Rating</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000953D.png" class="logo"
                alt="ICICI Prudential Overnight Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>ICICI Prudential Overnight Fund</h3><span class="subText">Fixed Income • Overnight • Direct
                  Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">6.17%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.1%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns on Maturity</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Credit Rating</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C00009534.png" class="logo"
                alt="HDFC Overnight Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>HDFC Overnight Fund</h3><span class="subText">Fixed Income • Overnight • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">6.14%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.1%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns on Maturity</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(231, 157, 13);">Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#E79D0D" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#E79D0D" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Credit Rating</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C000049GD.png" class="logo"
                alt="Axis Overnight Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>Axis Overnight Fund</h3><span class="subText">Fixed Income • Overnight • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">6.22%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.05%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns on Maturity</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Credit Rating</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000349B.png" class="logo"
                alt="Aditya BSL Overnight Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>Aditya BSL Overnight Fund</h3><span class="subText">Fixed Income • Overnight • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">6.19%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.05%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns on Maturity</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Credit Rating</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div><a class="viewAll navSection" href="/mutual-funds/explore/alternative-to-savings-account">View all
            funds</a>
        </div>
      </template>
      <template v-if="activeTab==='tab3'">
        <div class="content">
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000CX2H.png" class="logo"
                alt="DSP ELSS Tax Saver Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>DSP ELSS Tax Saver Fund</h3><span class="subText">Equity • ELSS (Tax Savings) • Direct Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">17.60%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.72%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Risk vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(219, 84, 42);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#DB542A" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#DB542A" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000BRKM.png" class="logo"
                alt="Mirae Asset ELSS Tax Saver Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>Mirae Asset ELSS Tax Saver Fund</h3><span class="subText">Equity • ELSS (Tax Savings) • Direct
                  Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">13.43%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.57%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Risk vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(231, 157, 13);">Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#E79D0D" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#E79D0D" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000953B.png" class="logo"
                alt="Canara Robeco ELSS Tax Saver" width="32" height="32" loading="lazy">
              <div>
                <h3>Canara Robeco ELSS Tax Saver</h3><span class="subText">Equity • ELSS (Tax Savings) • Direct
                  Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">12.64%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.58%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Risk vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Below Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="0.3"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000CU70.png" class="logo"
                alt="Bandhan ELSS Tax saver Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>Bandhan ELSS Tax saver Fund</h3><span class="subText">Equity • ELSS (Tax Savings) • Direct
                  Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">14.31%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.67%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Risk vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(219, 84, 42);">High</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#DB542A" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#DB542A" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#DB542A" opacity="1">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fundDetailsCard" style="background-color: rgb(245, 245, 245);"><img
              src="/mutual-funds/_next/static/3b711c449f43b4a9fc92b9b566045af3.svg" class="ribbon" alt="Top rated">
            <div class="topRatedFundsData"><img
                src="https://assets.upstox.com/content/assets/images/fundhouse/0C00001P1X.png" class="logo"
                alt="Kotak ELSS Tax Saver Fund" width="32" height="32" loading="lazy">
              <div>
                <h3>Kotak ELSS Tax Saver Fund</h3><span class="subText">Equity • ELSS (Tax Savings) • Direct
                  Growth</span>
              </div>
            </div>
            <div class="topRatedFundsDetails">
              <div class="rowInfo">
                <div class="infoLabel">3Y CAGR</div>
                <div class="infoValue">15.09%</div>
              </div>
              <div class="rowInfo">
                <div class="infoLabel">Expense ratio</div>
                <div class="infoValue">0.67%</div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Returns vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(20, 133, 100);">Above Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#148564" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#148564" opacity="1"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#148564" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
              <div class="rowInfo rowInfoMinWidth">
                <div class="infoLabel">Risk vs category</div>
                <div class="infoValue">
                  <div class="ratingIndicator"><span style="color: rgb(231, 157, 13);">Average</span>
                    <div class="iconContainer smallIcon"><svg xmlns="http://www.w3.org/2000/svg" width="100%"
                        height="100%" viewBox="0 0 16 16" fill="none">
                        <path d="M1.33301 9.33398H3.19967V14.6673H1.33301V9.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M4.2002 7.33398H6.06686V14.6673H4.2002V7.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M7.06641 5.33398H8.93307V14.6673H7.06641V5.33398Z" fill="#E79D0D" opacity="1"></path>
                        <path d="M9.93359 3.33398H11.8003V14.6673H9.93359V3.33398Z" fill="#E79D0D" opacity="0.3"></path>
                        <rect x="12.7998" y="1.33398" width="1.86667" height="13.3333" fill="#E79D0D" opacity="0.3">
                        </rect>
                      </svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div><a class="viewAll navSection" href="/mutual-funds/explore/save-taxes">View all funds</a>
        </div>
      </template>
    </div>
  </div>
  <div class="investmentIdeasContainer">
    <div class="investmentIdeas">
      <h2>Investment Ideas</h2>
      <div class="carouselContainer" @onScroll="scrollFun">
        <div class="carousel">
          <div class="carouselSlide idea" data-slide-number="1"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/become-a-crorepati-funds-list">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_become_crorepati.png"
                  style="background-color: #fcbc69" alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>Become a Crorepati</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="2"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/invest-in-global-funds">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_international_brands.png"
                  style="background-color: #af93cf" alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>Invest globally</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="3"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/dynamic-hybrid-funds">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_all_weather.png" style="background-color: #7acece"
                  alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>All weather investing</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="4"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/invest-in-gold-funds">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_invest_gold.png" style="background-color: #fcbc69"
                  alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>Invest in Gold</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="5"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/high-risk-high-return-funds">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_low_risk_high_returns.png"
                  style="background-color: #7acece" alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>High risk high returns</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="6"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/bank-account-alternative-funds">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_fd_alternate.png" style="background-color: #fd8e6e"
                  alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>Alternate to banks</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="7"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/explore/tax-savings-funds">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/sl_save_taxes.png" style="background-color: #fd8e6e"
                  alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>Save taxes</h3>
              </div>
            </a>
          </div>
          <div class="carouselSlide idea" data-slide-number="8"
            style="scroll-snap-align: start; margin-right: 0; margin-left: 0">
            <a href="/mutual-funds/new-fund-offering?cType=nfo&amp;nfo=true">
              <div>
                <img src="https://assets.upstox.com/mutualfunds/images/NFO.png" style="background-color: #fcbc69"
                  alt="Investment Idea" width="88" height="88" loading="lazy" />
                <h3>Ongoing NFOs</h3>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="arrowContainer carouselArrows">
        <button class="carouselArrow">
          <span class="icon medium"><svg viewBox="0 0 24 24" role="presentation">
              <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
                style="fill: currentColor"></path>
            </svg></span></button><button class="carouselArrow">
          <span class="icon medium"><svg viewBox="0 0 24 24" role="presentation">
              <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                style="fill: currentColor"></path>
            </svg></span>
        </button>
      </div>
    </div>
  </div>
  <div class="fundCategories">
    <div class="headingRow">
      <h2>Explore all fund categories</h2>
    </div>
    <div class="largeTabs">
      <div class="tab bottom" v-for="(item,index) in fundCategories.data" :class="{active:fundTab===index}" @click="onFundTabChange(index)"><span
          :data-id="item.title">{{item.title}}</span></div>
    </div>
    <div>
      <div class="categoryList" v-for="item in fundCategories.data[fundTab].sections">
        <h3>{{item.title}}</h3>
        <ul class="categoryListParent">
          <a v-for="child in item.categories">
            <li>
              <img width="40" height="40" loading="lazy"
                :src="child.logoUrl"
                :alt="child.title" :style="{backgroundColor: child.bgColor}" />
              <div class="content">
                <h4>{{child.title}}</h4>
                <p>{{child.description}}</p>
              </div>
            </li>
          </a>
        </ul>
      </div>
    </div>
    <button class="button outlined viewAllButton">
      <div class="buttonContent">
        <span><a>View All</a></span>
      </div>
    </button>
  </div>
  <div id="home-portal">
    <div class="popupBottomSheet"></div>
    <div class="popupBottomSheet"></div>
    <div class="popupBottomSheet"></div>
    <div class="popupBottomSheet"></div>
    <div class="popupBottomSheet"></div>
    <div class="popupBottomSheet"></div>
  </div>
</template>
<style scoped/>
<style src="@/styles/css/styles.0749e227.chunk.css" scoped/>
<style src="@/styles/css/fd8ea90bb49202a10512bd09038317d761693ce8_CSS.3e73b7cb.chunk.css" scoped/>
<style src="@/styles/css/82c472e12332d810c4ef757b3954290171f777ed_CSS.37a0a703.chunk.css" scoped/>
<style src="@/styles/css/f076ace415d176339ae0349d08ea8df31f612063_CSS.f5679918.chunk.css" scoped>
  /* @import "@/styles/css/23.355c19ee.chunk.css"; */
  
  /* @import "@/styles/css/styles.0749e227.chunk.css"; */
  /* @import "@/styles/css/fd8ea90bb49202a10512bd09038317d761693ce8_CSS.3e73b7cb.chunk.css"; */
  /* @import "@/styles/css/82c472e12332d810c4ef757b3954290171f777ed_CSS.37a0a703.chunk.css"; */
  /* @import "@/styles/css/f076ace415d176339ae0349d08ea8df31f612063_CSS.f5679918.chunk.css"; */
</style>